/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  z as zod
} from 'zod';

import type {
  ApiEnvelopeSeedCrackClearResultDto,
  ApiEnvelopeSeedCrackInsertResultDto,
  ApiEnvelopeSeedCrackWorldDetailDto,
  ApiEnvelopeSeedCrackWorldListDto,
  ApiEnvelopeWorldMapFeaturesDto,
  SeedCrackClearWorldParams,
  SeedCrackDeepCrackParams,
  SeedCrackDeleteFortressParams,
  SeedCrackGetMapFeaturesParams,
  SeedCrackGetMapTileParams,
  SeedCrackGetWorldParams,
  StructureObservationCreateRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type seedCrackAddStructuresResponse200 = {
  data: ApiEnvelopeSeedCrackInsertResultDto
  status: 200
}

export type seedCrackAddStructuresResponse400 = {
  data: ApiEnvelopeSeedCrackInsertResultDto
  status: 400
}

export type seedCrackAddStructuresResponse401 = {
  data: ApiEnvelopeSeedCrackInsertResultDto
  status: 401
}

export type seedCrackAddStructuresResponseSuccess = (seedCrackAddStructuresResponse200) & {
  headers: Headers;
};
export type seedCrackAddStructuresResponseError = (seedCrackAddStructuresResponse400 | seedCrackAddStructuresResponse401) & {
  headers: Headers;
};

export type seedCrackAddStructuresResponse = (seedCrackAddStructuresResponseSuccess | seedCrackAddStructuresResponseError)

export const getSeedCrackAddStructuresUrl = () => {




  return `/api/SeedCrack/structures`
}

export const useSeedCrackAddStructuresHook = (): (structureObservationCreateRequest?: StructureObservationCreateRequest[], options?: RequestInit) => Promise<seedCrackAddStructuresResponse> => {

      const customFetcher = useSfetchMutator();
      return (structureObservationCreateRequest?: StructureObservationCreateRequest[], options?: RequestInit) => {

        return customFetcher(getSeedCrackAddStructuresUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(structureObservationCreateRequest)
  }
);
      }
  }


export type seedCrackGetWorldsResponse200 = {
  data: ApiEnvelopeSeedCrackWorldListDto
  status: 200
}

export type seedCrackGetWorldsResponse401 = {
  data: ApiEnvelopeSeedCrackWorldListDto
  status: 401
}

export type seedCrackGetWorldsResponseSuccess = (seedCrackGetWorldsResponse200) & {
  headers: Headers;
};
export type seedCrackGetWorldsResponseError = (seedCrackGetWorldsResponse401) & {
  headers: Headers;
};

export type seedCrackGetWorldsResponse = (seedCrackGetWorldsResponseSuccess | seedCrackGetWorldsResponseError)

export const getSeedCrackGetWorldsUrl = () => {




  return `/api/SeedCrack/worlds`
}

export const useSeedCrackGetWorldsHook = (): ( options?: RequestInit) => Promise<seedCrackGetWorldsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getSeedCrackGetWorldsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type seedCrackGetWorldResponse200 = {
  data: ApiEnvelopeSeedCrackWorldDetailDto
  status: 200
}

export type seedCrackGetWorldResponse401 = {
  data: ApiEnvelopeSeedCrackWorldDetailDto
  status: 401
}

export type seedCrackGetWorldResponse404 = {
  data: ApiEnvelopeSeedCrackWorldDetailDto
  status: 404
}

export type seedCrackGetWorldResponseSuccess = (seedCrackGetWorldResponse200) & {
  headers: Headers;
};
export type seedCrackGetWorldResponseError = (seedCrackGetWorldResponse401 | seedCrackGetWorldResponse404) & {
  headers: Headers;
};

export type seedCrackGetWorldResponse = (seedCrackGetWorldResponseSuccess | seedCrackGetWorldResponseError)

export const getSeedCrackGetWorldUrl = (params?: SeedCrackGetWorldParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SeedCrack/world?${stringifiedParams}` : `/api/SeedCrack/world`
}

export const useSeedCrackGetWorldHook = (): (params?: SeedCrackGetWorldParams, options?: RequestInit) => Promise<seedCrackGetWorldResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: SeedCrackGetWorldParams, options?: RequestInit) => {

        return customFetcher(getSeedCrackGetWorldUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type seedCrackClearWorldResponse200 = {
  data: ApiEnvelopeSeedCrackClearResultDto
  status: 200
}

export type seedCrackClearWorldResponse400 = {
  data: ApiEnvelopeSeedCrackClearResultDto
  status: 400
}

export type seedCrackClearWorldResponse401 = {
  data: ApiEnvelopeSeedCrackClearResultDto
  status: 401
}

export type seedCrackClearWorldResponseSuccess = (seedCrackClearWorldResponse200) & {
  headers: Headers;
};
export type seedCrackClearWorldResponseError = (seedCrackClearWorldResponse400 | seedCrackClearWorldResponse401) & {
  headers: Headers;
};

export type seedCrackClearWorldResponse = (seedCrackClearWorldResponseSuccess | seedCrackClearWorldResponseError)

export const getSeedCrackClearWorldUrl = (params?: SeedCrackClearWorldParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SeedCrack/world?${stringifiedParams}` : `/api/SeedCrack/world`
}

export const useSeedCrackClearWorldHook = (): (params?: SeedCrackClearWorldParams, options?: RequestInit) => Promise<seedCrackClearWorldResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: SeedCrackClearWorldParams, options?: RequestInit) => {

        return customFetcher(getSeedCrackClearWorldUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type seedCrackDeepCrackResponse200 = {
  data: ApiEnvelopeSeedCrackWorldDetailDto
  status: 200
}

export type seedCrackDeepCrackResponse400 = {
  data: ApiEnvelopeSeedCrackWorldDetailDto
  status: 400
}

export type seedCrackDeepCrackResponse401 = {
  data: ApiEnvelopeSeedCrackWorldDetailDto
  status: 401
}

export type seedCrackDeepCrackResponse404 = {
  data: ApiEnvelopeSeedCrackWorldDetailDto
  status: 404
}

export type seedCrackDeepCrackResponseSuccess = (seedCrackDeepCrackResponse200) & {
  headers: Headers;
};
export type seedCrackDeepCrackResponseError = (seedCrackDeepCrackResponse400 | seedCrackDeepCrackResponse401 | seedCrackDeepCrackResponse404) & {
  headers: Headers;
};

export type seedCrackDeepCrackResponse = (seedCrackDeepCrackResponseSuccess | seedCrackDeepCrackResponseError)

export const getSeedCrackDeepCrackUrl = (params?: SeedCrackDeepCrackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SeedCrack/deepcrack?${stringifiedParams}` : `/api/SeedCrack/deepcrack`
}

export const useSeedCrackDeepCrackHook = (): (params?: SeedCrackDeepCrackParams, options?: RequestInit) => Promise<seedCrackDeepCrackResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: SeedCrackDeepCrackParams, options?: RequestInit) => {

        return customFetcher(getSeedCrackDeepCrackUrl(params),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type seedCrackDeleteFortressResponse200 = {
  data: ApiEnvelopeSeedCrackClearResultDto
  status: 200
}

export type seedCrackDeleteFortressResponse400 = {
  data: ApiEnvelopeSeedCrackClearResultDto
  status: 400
}

export type seedCrackDeleteFortressResponse401 = {
  data: ApiEnvelopeSeedCrackClearResultDto
  status: 401
}

export type seedCrackDeleteFortressResponseSuccess = (seedCrackDeleteFortressResponse200) & {
  headers: Headers;
};
export type seedCrackDeleteFortressResponseError = (seedCrackDeleteFortressResponse400 | seedCrackDeleteFortressResponse401) & {
  headers: Headers;
};

export type seedCrackDeleteFortressResponse = (seedCrackDeleteFortressResponseSuccess | seedCrackDeleteFortressResponseError)

export const getSeedCrackDeleteFortressUrl = (params?: SeedCrackDeleteFortressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SeedCrack/fortress?${stringifiedParams}` : `/api/SeedCrack/fortress`
}

export const useSeedCrackDeleteFortressHook = (): (params?: SeedCrackDeleteFortressParams, options?: RequestInit) => Promise<seedCrackDeleteFortressResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: SeedCrackDeleteFortressParams, options?: RequestInit) => {

        return customFetcher(getSeedCrackDeleteFortressUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type seedCrackGetMapTileResponse200 = {
  data: Blob
  status: 200
}

export type seedCrackGetMapTileResponse404 = {
  data: Blob
  status: 404
}

export type seedCrackGetMapTileResponseSuccess = (seedCrackGetMapTileResponse200) & {
  headers: Headers;
};
export type seedCrackGetMapTileResponseError = (seedCrackGetMapTileResponse404) & {
  headers: Headers;
};

export type seedCrackGetMapTileResponse = (seedCrackGetMapTileResponseSuccess | seedCrackGetMapTileResponseError)

export const getSeedCrackGetMapTileUrl = (z: number,
    x: number,
    y: number,
    params?: SeedCrackGetMapTileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SeedCrack/map/tile/${z}/${x}/${y}?${stringifiedParams}` : `/api/SeedCrack/map/tile/${z}/${x}/${y}`
}

export const useSeedCrackGetMapTileHook = (): (z: number,
    x: number,
    y: number,
    params?: SeedCrackGetMapTileParams, options?: RequestInit) => Promise<seedCrackGetMapTileResponse> => {

      const customFetcher = useSfetchMutator();
      return (z: number,
    x: number,
    y: number,
    params?: SeedCrackGetMapTileParams, options?: RequestInit) => {

        return customFetcher(getSeedCrackGetMapTileUrl(z,x,y,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type seedCrackGetMapFeaturesResponse200 = {
  data: ApiEnvelopeWorldMapFeaturesDto
  status: 200
}

export type seedCrackGetMapFeaturesResponse404 = {
  data: ApiEnvelopeWorldMapFeaturesDto
  status: 404
}

export type seedCrackGetMapFeaturesResponseSuccess = (seedCrackGetMapFeaturesResponse200) & {
  headers: Headers;
};
export type seedCrackGetMapFeaturesResponseError = (seedCrackGetMapFeaturesResponse404) & {
  headers: Headers;
};

export type seedCrackGetMapFeaturesResponse = (seedCrackGetMapFeaturesResponseSuccess | seedCrackGetMapFeaturesResponseError)

export const getSeedCrackGetMapFeaturesUrl = (params?: SeedCrackGetMapFeaturesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SeedCrack/map/features?${stringifiedParams}` : `/api/SeedCrack/map/features`
}

export const useSeedCrackGetMapFeaturesHook = (): (params?: SeedCrackGetMapFeaturesParams, options?: RequestInit) => Promise<seedCrackGetMapFeaturesResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: SeedCrackGetMapFeaturesParams, options?: RequestInit) => {

        return customFetcher(getSeedCrackGetMapFeaturesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


